// Unified application status config used across student and employer portals
export type ApplicationStatus =
  | "aplicada"
  | "triagem"
  | "entrevista_rh"
  | "entrevista_gestor"
  | "proposta"
  | "contratado"
  | "nao_avancou"
  | "desistiu";

export const APPLICATION_STATUS_CONFIG: Record<string, { label: string; color: string; nextStates: string[] }> = {
  aplicada: { label: "Aplicada", color: "bg-gray-100 text-gray-700", nextStates: ["triagem", "nao_avancou"] },
  triagem: { label: "Em Triagem", color: "bg-yellow-100 text-yellow-800", nextStates: ["entrevista_rh", "nao_avancou"] },
  entrevista_rh: { label: "Entrevista RH", color: "bg-blue-100 text-blue-800", nextStates: ["entrevista_gestor", "nao_avancou"] },
  entrevista_gestor: { label: "Entrevista Gestor", color: "bg-purple-100 text-purple-800", nextStates: ["proposta", "nao_avancou"] },
  proposta: { label: "Proposta", color: "bg-indigo-100 text-indigo-800", nextStates: ["contratado", "nao_avancou"] },
  contratado: { label: "Contratado", color: "bg-green-100 text-green-800", nextStates: [] },
  nao_avancou: { label: "Não Avançou", color: "bg-gray-100 text-gray-600", nextStates: [] },
  desistiu: { label: "Desistiu", color: "bg-red-100 text-red-700", nextStates: [] },
};

// Ordered pipeline steps for timeline display
export const PIPELINE_STEPS = [
  "aplicada",
  "triagem",
  "entrevista_rh",
  "entrevista_gestor",
  "proposta",
  "contratado",
];

export function getStatusLabel(status: string): string {
  return APPLICATION_STATUS_CONFIG[status]?.label ?? status;
}

export function getStatusColor(status: string): string {
  return APPLICATION_STATUS_CONFIG[status]?.color ?? "bg-gray-100 text-gray-700";
}
